import React from 'react';

export const EmailIcon = ({ size = 24, color }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill={color} xmlns="http://www.w3.org/2000/svg" >
    <path fillRule="evenodd" clipRule="evenodd" d="M1.92924 3.8007L8 8.05014L14.0708 3.8007C13.9684 3.46364 13.6532 3.21542 13.2846 3.21542H2.71543C2.34678 3.21542 2.03159 3.46364 1.92924 3.8007ZM14.1057 4.99688L8.28673 9.07008C8.11457 9.19059 7.88543 9.19059 7.71327 9.07008L1.89429 4.99688V11.9634C1.89429 12.4139 2.26494 12.7846 2.71543 12.7846H13.2846C13.7351 12.7846 14.1057 12.4139 14.1057 11.9634V4.99688ZM0.894287 4.03657C0.894287 3.0338 1.71266 2.21542 2.71543 2.21542H13.2846C14.2873 2.21542 15.1057 3.03379 15.1057 4.03657V11.9634C15.1057 12.9662 14.2873 13.7846 13.2846 13.7846H2.71543C1.71266 13.7846 0.894287 12.9662 0.894287 11.9634V4.03657Z" />
  </svg>
);


// WEBPACK FOOTER //
// ./src/assets/icons/Email.icon.jsx